<template>
  <div>
    <div class="battery-order-view__container battery-order-view__container--form">
      <div class="battery-order-view__row battery-order-view__row--title">
        Add Items
      </div>
      <div class="battery-order-view__row battery-order-view__row--imprint">
        <p>Add imprinting to your battery cards with your logo and/or text.</p>
        <p>If this is your first time ordering or you would like to update your imprint, select <strong>New Imprint</strong>. We will contact you to get your new imprint setup.</p>
        <p>If you already have imprinting and would like to order more batteries, select <strong>Current Imprint</strong>.</p>
        <p>If you don’t want imprinting on your battery cards, select <strong>No Imprint</strong>.</p>
      </div>
      <ProductForm></ProductForm>
    </div>
    <ProductCartView></ProductCartView>
    <div class="battery-store__unmet-minimum h-helper-text h-center-align" v-if="hasPowerOne && !meetsCartonMinimum">There is a 10 carton minimum purchase requirement for Power One orders</div>
    <div class="battery-store__unmet-minimum h-helper-text h-center-align" v-if="hasRayovac && !meetsDollarMinimum">There is a $100 minimum purchase requirement for Rayovac orders</div>
    <div class="battery-store__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="nextStep" :disabled="!isOrderValid">Add Shipping Info</button>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import DataMethods from '../utils/DataMethods.js';
  import Product from './products/Product.vue';
  import ProductForm from './products/ProductForm.vue';
  import ProductHeader from './products/ProductHeader.vue';
  import ProductCartView from './products/ProductCartView.vue';

  export default {
    name: 'ProductView',
    mixins: [DataMethods],
    components: {
      Product,
      ProductForm,
      ProductHeader,
      ProductCartView,
    },
    computed: {
      ...mapGetters('batteryStore', ['loaders', 'orderProducts']),
      hasPowerOne() {
        return this.powerOneProducts.length > 0;
      },
      powerOneProducts() {
        return lodash.filter(this.orderProducts, product => product.battery_line === 'Power One');
      },
      numberOfCartons() {
        return lodash.reduce(this.powerOneProducts, (sum, product) => parseInt(product.quantity) + sum, 0);
      },
      meetsCartonMinimum() {
        return lodash.reduce(this.powerOneProducts, (sum, product) => parseInt(product.quantity) + sum, 0) > 1;
      },
      hasRayovac() {
        return this.rayovacProducts.length > 0;
      },
      rayovacProducts() {
        return lodash.filter(this.orderProducts, product => product.battery_line != 'Power One');
      },
      rayovacDollars() {
        return lodash.reduce(this.rayovacProducts, (sum, product) => parseInt(product.subtotal) + sum, 0);
      },
      meetsDollarMinimum() {
        return !(this.rayovacDollars < 10000);
      },
      isOrderValid() {
        if (this.orderProducts.length === 0) {
          return false;
        }
        if (this.hasPowerOne) {
          if (!this.meetsCartonMinimum) {
            return false;
          }
        }
        if (this.hasRayovac) {
          if (!this.meetsDollarMinimum) {
            return false;
          }
        }
        return true;
      },
    },
    methods: {
      nextStep() {
        this.$store.dispatch('batteryStore/setProperty', { key: 'currentSection', value: 'shippingInfo'});
      },
    },
  };
</script>
